import _typeof from '@babel/runtime/helpers/typeof';

var componentWithName = function componentWithName(passedName) {
  if (typeof passedName !== 'string') {
    throw new Error('passedName must be a string');
  }

  var checkProp = function checkProp(props, propName, componentName) {
    if (Array.isArray(props[propName])) {
      return props[propName].map(function (_, index) {
        return checkProp(props[propName], index, componentName);
      }).find(Boolean);
    }

    var prop = props[propName]; // check if this is a react element

    if (prop && prop.$$typeof !== Symbol.for('react.element')) {
      return new Error("".concat(componentName, ": Component passed to `").concat(propName, "` prop should be a React.element"));
    }

    if (prop && _typeof(prop) !== 'object' || prop && prop.type.name !== passedName) {
      return new Error("".concat(componentName, ": Component passed to `").concat(propName, "` prop should be ").concat(passedName));
    }

    return undefined;
  };

  var checkRequired = function checkRequired(props, propName, componentName) {
    if (props[propName] === undefined) {
      return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is ").concat(props[propName], "."));
    }

    return undefined;
  };

  var createValidate = function createValidate(isRequired) {
    if (isRequired) {
      return function (props, propName, componentName) {
        var checkForError = checkProp(props, propName, componentName);

        if (checkForError) {
          return checkForError;
        }

        return checkRequired(props, propName, componentName);
      };
    }

    return checkProp;
  };

  var validate = createValidate();
  validate.isRequired = createValidate(true);
  return validate;
};

export default componentWithName;
